import React from 'react';
import {Icon} from 'semantic-ui-react';
import PropTypes from 'prop-types';

import {convertToInt} from '@utils/helpers';
import Link from '@appComponents/Link';

const ChangelogLink = ({resources, elementId}) => (
    <div className='formRow'>
        <div className='changelogData__row'>
            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <label />
            <span className='changelogData__info'>
                <Link name='changelog.changelogElement' newWindow={true} params={{
                    resourceId: resources,
                    elementId: convertToInt(elementId),
                }}>
                    <Icon name='file alternate outline' style={{marginLeft: 0}}/>
                    <span className='changelogData__info'>{'Changelog'}</span>
                </Link>
            </span>
        </div>
    </div>
);

ChangelogLink.propTypes = {
    elementId: PropTypes.string,
    resources: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.arrayOf(PropTypes.number),
    ]),
};

export default ChangelogLink;
